import { Injectable, signal, WritableSignal } from '@angular/core';

import { TimerPreviewState } from '../components/timer-config/timer.model';

// providedIn: 'root' so the editor (deep in form tree) and the preview drawer (sibling subtree)
// share one instance — these flags are transient, not persisted.
@Injectable({ providedIn: 'root' })
export class SmartCartPreviewStateService {
  readonly showEmptyCart: WritableSignal<boolean> = signal(false);

  readonly goalsPreviewGoalIndex: WritableSignal<number> = signal(0);
  readonly goalsPreviewMet: WritableSignal<boolean> = signal(false);
  readonly goalsPreviewTimerState: WritableSignal<TimerPreviewState> = signal('default');
  readonly upsellPreviewTimerState: WritableSignal<TimerPreviewState> = signal('default');
  readonly digitalUpsellPreviewTimerState: WritableSignal<TimerPreviewState> = signal('default');

  toggleShowEmptyCart(): void {
    this.showEmptyCart.update((v) => !v);
  }

  setGoalsPreview(index: number, met: boolean): void {
    this.goalsPreviewGoalIndex.set(index);
    this.goalsPreviewMet.set(met);
  }

  setGoalsPreviewTimerState(state: TimerPreviewState): void {
    this.goalsPreviewTimerState.set(state);
  }

  setUpsellPreviewTimerState(state: TimerPreviewState): void {
    this.upsellPreviewTimerState.set(state);
  }

  setDigitalUpsellPreviewTimerState(state: TimerPreviewState): void {
    this.digitalUpsellPreviewTimerState.set(state);
  }
}
